import { Link } from "react-router-dom";
import { ArrowRight, SealCheck, MapPin } from "@phosphor-icons/react";
import { Reveal } from "../components/Reveal";
import PageHero from "../components/PageHero";
import Seo from "../components/Seo";
import { ABOUT, BEN_PHOTO_URL, GALLERY } from "../data/content";

const About = () => (
  <main data-testid="about-page" className="bg-brand-bone">
    <Seo
      title="About Ben Kill, Director"
      description="Meet Ben Kill CeMAP, Director of BTK Mortgage Services. A boutique mortgage and protection practice based in Berkshire, serving clients across the UK."
      path="/about"
      image={GALLERY[2]}
    />
    <PageHero
      testId="about-hero"
      eyebrow="About · The Director"
      title="A boutique mortgage"
      italic="& protection practice."
      intro={ABOUT.intro}
      image={GALLERY[2]}
    />

    <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
      <div className="grid gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative mx-auto max-w-sm lg:sticky lg:top-28">
              <div aria-hidden className="absolute -inset-4 border border-brand-gold/40" />
              <img
                src={BEN_PHOTO_URL}
                alt="Ben Kill CeMAP, Director of BTK Mortgage Services"
                data-testid="about-director-photo"
                className="relative aspect-[4/5] w-full object-cover shadow-[0_32px_80px_rgba(10,19,38,0.18)]"
              />
              <div className="absolute -bottom-6 left-6 right-6 bg-white p-6 shadow-[0_16px_48px_rgba(10,19,38,0.14)]">
                <p data-testid="about-director-name" className="editorial-h text-xl text-brand-ink">
                  {ABOUT.name}
                </p>
                <p className="mt-1 text-[0.72rem] font-semibold uppercase tracking-[0.22em] text-neutral-500">
                  {ABOUT.role} · BTK Mortgage Services
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="eyebrow text-brand">
              <span className="rule-line" />
              {ABOUT.heading}
            </p>
            <h2 className="editorial-h mt-7 text-3xl text-brand-ink sm:text-5xl">
              {ABOUT.name}
            </h2>
            <p className="mt-3 text-[0.78rem] font-semibold uppercase tracking-[0.32em] text-neutral-500">
              {ABOUT.role}
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <blockquote
              data-testid="about-director-quote"
              className="editorial-h mt-12 border-l-2 border-brand-gold pl-6 text-xl leading-relaxed text-brand-ink sm:text-2xl"
            >
              <span className="text-brand-gold text-4xl leading-none">“</span>
              {ABOUT.quote}”
            </blockquote>
          </Reveal>

          <Reveal delay={0.22}>
            <div className="mt-14 grid gap-4 sm:grid-cols-2">
              <div className="border border-black/10 bg-white p-8">
                <SealCheck size={26} weight="duotone" className="text-brand" />
                <h3 className="editorial-h mt-5 text-lg text-brand-ink">CeMAP qualified</h3>
                <p className="mt-3 text-sm leading-relaxed text-neutral-600">
                  Fully qualified mortgage &amp; protection advisers. An Appointed Representative of PRIMIS
                  Mortgage Network.
                </p>
              </div>
              <div className="border border-black/10 bg-white p-8">
                <MapPin size={26} weight="duotone" className="text-brand" />
                <h3 className="editorial-h mt-5 text-lg text-brand-ink">Berkshire based, UK wide</h3>
                <p className="mt-3 text-sm leading-relaxed text-neutral-600">
                  Based in Berkshire — advising clients across Berkshire, London, Surrey and the
                  rest of the UK.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.28}>
            <Link
              to="/contact"
              data-testid="about-contact-btn"
              className="group mt-14 inline-flex items-center gap-2 bg-brand px-8 py-4 text-[0.78rem] font-semibold uppercase tracking-[0.22em] text-white shadow-[0_14px_40px_rgba(1,86,207,0.35)] transition-[background-color,transform] duration-200 hover:bg-brand-dark hover:-translate-y-0.5"
            >
              Speak to Ben
              <ArrowRight size={14} weight="bold" className="transition-transform duration-200 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  </main>
);

export default About;
